import { createContext, useState, useContext } from 'react';

const initialValue = [{title: 'Home'}, {title: 'Event Table'}];

const BreadCrumbContext = createContext();

function BreadCrumbProvider({children}) {
    const [breadcrumbs, setBreadcrumbs] = useState(initialValue)
    return (
        <BreadCrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
            {children}
        </BreadCrumbContext.Provider>
    )
}

/**
 * Custom hook to access and update breadcrumbs
 * @returns {Object} An object containing:
 * @returns {Array} .breadcrumbs - Current array of breadcrumb items
 * @returns {Function} .setBreadcrumbs - Function to update the breadcrumbs array
 * @throws {Error} If used outside of BreadCrumbProvider
 * @example
 * // Usage example:
 * const { breadcrumbs, setBreadcrumbs } = useBreadcrumbs();
 * // To update:
 * setBreadcrumbs([...breadcrumbs, { title: 'New Page' }]);
 */
function useBreadcrumbs() {
    const context = useContext(BreadCrumbContext);
    if (context === undefined) {
        throw new Error('useBreadcrumbs must be used within a BreadCrumbProvider');
    }
    return context;
}

export { BreadCrumbProvider, useBreadcrumbs };